import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { UserSettingsRoutesConfig } from 'domains/userSettings/Routes';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useIsXSDown } from 'uiKit/Theme/useTheme';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

export const useRedirectForSmallDevices = () => {
  const navigate = useNavigate();
  const isHidden = useIsXSDown();
  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  useEffect(() => {
    if (isHidden && !isPartnerStatusLoading) {
      if (isPartnerClient) {
        navigate(UserSettingsRoutesConfig.settings.generatePath(), {
          replace: true,
        });

        return;
      }

      navigate(chainsRoutesConfig.chains.generatePath(), {
        replace: true,
      });
    }
  }, [isHidden, navigate, isPartnerClient, isPartnerStatusLoading]);
};
